import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-only
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/cn.js';
/**
 * 1px `--border` rule, horizontal or vertical, with an optional centered
 * label ("or") — research/design-system.md Tier 1.
 */
export const dividerVariants = cva('border-0 bg-border', {
    variants: {
        orientation: {
            horizontal: 'h-px w-full',
            vertical: 'w-px self-stretch',
        },
    },
    defaultVariants: { orientation: 'horizontal' },
});
export function Divider({ className, orientation = 'horizontal', label, ...props }) {
    if (label !== undefined && orientation === 'horizontal') {
        return (_jsxs("div", { role: "separator", "aria-orientation": "horizontal", className: cn('flex w-full items-center gap-3 text-caption text-fg-subtle', className), ...props, children: [_jsx("span", { "aria-hidden": "true", className: "h-px flex-1 bg-border" }), label, _jsx("span", { "aria-hidden": "true", className: "h-px flex-1 bg-border" })] }));
    }
    return (_jsx("div", { role: "separator", "aria-orientation": orientation ?? 'horizontal', className: cn(dividerVariants({ orientation }), className), ...props }));
}
//# sourceMappingURL=Divider.js.map